import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import UrlPasteBlock from './UrlPasteBlock';

export const UrlPaste = Node.create({
  name: 'urlPaste',

  isolating: true,
  defining: true,
  group: 'block',
  draggable: true,
  selectable: true,
  inline: false,

  addAttributes() {
    return {
      url: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML() {
    return ['div', { 'data-type': this.name, class: 'urlpaste-block' }]
  },

  addCommands() {
    return {
      setUrlPaste:
        () =>
        ({ commands }) =>
          commands.insertContent(`<div data-type="${this.name}"></div>`),
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(UrlPasteBlock);
  },
});
